var map = {
	"./Accountancy.jpg": 25239,
	"./Banking and insurance.jpg": 95275,
	"./Chemical-industry.jpg": 69927,
	"./Cohesive Estonia.jpg": 55446,
	"./Commerce.jpg": 99000,
	"./Construction and real estate.jpg": 49954,
	"./Electronics_industry.jpg": 81609,
	"./Engineering-industry.jpg": 35446,
	"./Equal treatment.jpg": 5046,
	"./Food industry.jpg": 86815,
	"./Forestry and timber industry.jpg": 28210,
	"./HARJU_county.jpg": 15608,
	"./HIIU_county.jpg": 27667,
	"./IDA_county.jpg": 61853,
	"./Information and communication technology .jpg": 83747,
	"./JARVA_county.jpg": 42550,
	"./JOGEVA_county.jpg": 70486,
	"./LAANE_VIRU.jpg": 32097,
	"./LAANE_county.jpg": 26361,
	"./Main indicators.jpg": 34651,
	"./Marine industry.jpg": 92571,
	"./Ministry of Defence.jpg": 26122,
	"./Ministry of Economic Affairs and Communications.jpg": 37274,
	"./Ministry of Finance.jpg": 72885,
	"./Ministry of Foreign Affairs.jpg": 52621,
	"./Ministry of Justice.jpg": 38291,
	"./Ministry of Rural Affairs.jpg": 46519,
	"./Ministry of Social Affairs.jpg": 27750,
	"./Ministry of the Environment.jpg": 99271,
	"./Ministry of the Interior.jpg": 50226,
	"./PARNU_county.jpg": 32980,
	"./POLVA_county.jpg": 64937,
	"./Postal and courier activities.jpg": 88104,
	"./Printing-and-paper-industry.jpg": 63449,
	"./RAPLA_county.jpg": 75111,
	"./SAARE_county.jpg": 37872,
	"./Statistics on Tallinn.jpg": 88437,
	"./Sustainable development.jpg": 89758,
	"./TARTU_county.jpg": 45702,
	"./Tourism industry.jpg": 13588,
	"./VALGA_county.jpg": 23488,
	"./VILJANDI_county.jpg": 68,
	"./VORU_county.jpg": 8355,
	"./Whole.jpg": 92682,
	"./Youth monitoring.jpg": 99280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65513;